import { render, staticRenderFns } from "./OAuth2Callback.vue?vue&type=template&id=31391841&scoped=true"
import script from "./OAuth2Callback.vue?vue&type=script&lang=ts"
export * from "./OAuth2Callback.vue?vue&type=script&lang=ts"
import style0 from "./OAuth2Callback.vue?vue&type=style&index=0&id=31391841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31391841",
  null
  
)

export default component.exports